import './BlockChild.css';
import BlockLinkStart from '../BlockLinkStart/BlockLinkStart';
import { useBotStateContext } from '../../../contexts/BotContext';
import { useEffect, useState } from 'react';

function BlockChild({ style, className, zero, label, lowVersion, parent_block_id, object_id, is_not_link }) {
    const [printArrow, setPrintArrow] = useState(is_not_link)
    if (lowVersion) {
        return (
            <div className='sub_block' style={style}>
                <label className='sub_txt'>{label}</label>
                <div className={"sub_out_block " + className + " delete"}></div>
            </div>
        )
    }

    const { errors } = useBotStateContext();
    const block = errors[parent_block_id];
    var error = false
    if (block) {
        error = block.errors.filter(child => child.data && child.data.object_id == object_id).length ? true : false;
    }

    if (zero) {
        return (
            <div className='sub_block_zero'>
                <BlockLinkStart style={style} parent_block_id={parent_block_id} object_id={object_id} className={error ? 'sub_out_block_zero ripple part_error ' + className : 'sub_out_block_zero ' + className} />
            </div>
        )
    }

    style = { ...style, marginLeft: error ? -2 : 0 }
    
    if (printArrow != is_not_link){
        setPrintArrow(is_not_link);
    }


    return (
        <div className={error ? 'sub_block ripple part_error' : 'sub_block'} style={style}>
            <label className='sub_txt'>{label}</label>
            <div className='sub_connector' style={{ top: "-12px", height: "13px" }} />
            {
                printArrow != true &&
                <BlockLinkStart parent_block_id={parent_block_id} object_id={object_id}  className={error ? 'sub_out_block ripple delete ' + className : 'sub_out_block delete ' + className}/>
            }
        </div>
    )
}

BlockChild.defaultProps = {
    lowVersion: false
}

export default BlockChild;